<!--
 * @Author: Shao Wei
 * @Date: 2022-10-20 15:35:22
 * @LastEditors: Shao Wei
 * @LastEditTime: 2022-10-24 13:20:41
 * @Description: file content
 * @FilePath: /leopard-web-vehicle/src/views/finance/components/AlipayWithhold.vue
-->
<template>
<div>
  <dialogWrap
    v-model="isShow"

    title="创建支付宝支付收款单"
    @change="changeHandle"
    :width="'524px'"
  >
    <el-form
      ref="alipayWithhold"
      :model="alipayWithholdData"
      :rules="rules"
    >
      <el-form-item
        prop="collectibleAmount"
        label="最大可收金额："
      >{{collectibleAmount}}元</el-form-item>
      <el-form-item
        prop="receiveAmount"
        label="本次收款金额："
      >
        <el-col :span="12">
        <el-input
          v-limit-money="true"
          v-model="alipayWithholdData.receiveAmount"
          placeholder="请输入"
          class="width171"
          clearable
          maxlength="13"
        >
        <template slot="append">元</template>
        </el-input>
        </el-col>
      </el-form-item>
    </el-form>
      <template slot="footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button
          :loading="loading"
          size="small"
          type="primary"
          @click="initiateWithhold"
          >发起代扣</el-button
    >
    </template>
  </dialogWrap>
  <!-- 二次确认弹窗 -->
  <dialogWrap
    v-model="confirmShow"

    title="请确认代扣收款内容"
    :width="'524px'"
  >
    <el-form>
      <el-form-item label="本次收款金额：">
        {{parseFloat(alipayWithholdData.receiveAmount).toFixed(2)}}元
      </el-form-item>
      <el-form-item label="相关车辆：">
          {{receivableItem.plateNo}}
      </el-form-item>
      <el-form-item label="付款方：">
          {{receivableItem.customer}}
      </el-form-item>
      <el-form-item label="支付方式：">
          支付宝支付
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button size="small" @click="cancelConfirm">取消</el-button>
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        @click="onOk"
        >确认</el-button
      >
    </template>
  </dialogWrap>
</div>
</template>

<script>
import { addAlipayReceipt } from '@/api/financeApi'

export default {
  components: {},
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    receivableItem: { type: Object, default: () => ({}) },
  },
  watch: {
    show(val) { this.isShow = val },
    isShow(val) {
      this.$emit('change', val)
    },
  },
  data() {
    return {
      isShow: false,
      loading: false,
      confirmShow: false,
      alipayWithholdData: { receiveAmount: 0 },
    }
  },
  methods: {
    changeHandle(bol) {
      if (!bol) {
        this.$refs.alipayWithhold.resetFields()
      }
    },
    initiateWithhold() {
      // 表单验证
      this.$refs.alipayWithhold.validate((valid) => {
        if (valid) {
          this.confirmShow = true
        }
      })
    },
    cancel() {
      this.$refs.alipayWithhold.resetFields()
      this.isShow = false
    },
    cancelConfirm() { this.confirmShow = false },
    // 确认创建
    async onOk() {
      if (this.loading) return
      this.loading = true
      try {
        const { id: receivableId } = this.receivableItem
        const { receiveAmount: amount } = this.alipayWithholdData
        const { code } = await addAlipayReceipt({
          receivableId,
          amount,
        })
        if (code === 1) {
          this.confirmShow = false
          this.$message.success('收款单创建成功')
          this.isShow = false
        }
      } finally {
        this.loading = false
      }
    },
    validatePass(rule, value, callback) {
      if (!value) { callback(new Error('收款金额不能为空！')) }
      if (!Number(value)) { callback(new Error('收款金额不能为零！')) }
      if (Number(value) > Number(this.collectibleAmount)) {
        callback(new Error('不能超过最大可收金额！'))
      }
      callback()
    },
  },
  computed: {
    rules() {
      return {
        receiveAmount: [
          { validator: this.validatePass, trigger: 'blur' },
        ],
      }
    },
    collectibleAmount() {
      // 最大可收金额：应收金额-收款中金额-已收金额
      const { receivableAmount, receivedAmount, receivingAmount } = this.receivableItem
      return (Number(receivableAmount) - Number(receivedAmount) - Number(receivingAmount)).toFixed(2)
    },
  },
}
</script>

<style scoped lang="scss">
.box-wrap {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
</style>
